import { AccountDto } from '../routes/account/store/Account';
import { LabelsDto } from '../routes/account/store/Labels';
import { ServiceDto } from '../routes/account/store/services/Service';
import { PulseCdnConnectDto } from '../routes/account/store/services/storages/PulseCdnStorage';
import ApiHttpClient from './ApiHttpClient';

export default class Account {
  constructor(private readonly client: ApiHttpClient) {}

  async connectPulseCdn(): Promise<PulseCdnConnectDto> {
    return this.client.post(`v1/provider/account/pulsecdn/connect`, {});
  }

  async deleteService({ provider, name }: ServiceDto) {
    return this.client.delete(`v1/provider/account/services/${provider}`, {
      query: {
        ...(name && { name }),
      },
    });
  }

  async getAccount(): Promise<AccountDto> {
    return this.client.get('v1/provider/account');
  }

  async sendEmailToMyself(message: { body: string; subject: string }) {
    return this.client.post(`v1/provider/account/sendEmailToMyself`, message);
  }

  async saveAccount(account: AccountDto) {
    return this.client.put('v1/provider/account', account);
  }

  async updateLabels(labels: LabelsDto) {
    return this.client.put('v1/provider/account/labels', labels);
  }

  async updateServices(services: ServiceDto[]) {
    return this.client.post(`v1/provider/account/services`, services);
  }
}
